import React from "react";
import classes from "./BurgerIngredient.module.css";

function BreadBottom() {
  return <div className={classes.BreadBottom}></div>;
}

export default BreadBottom;
